import { IUserDisplayData } from '@gem/models/userModel';

import { Workspace_Role } from 'APP/wsApi/wsAppApi/types/workspace/workspace_model_pb';

export interface IUsersInWorkspaceRequest {
  cursor?: string;
  limit?: number;
}

export interface ISearchUsersInWorkspaceRequest extends IUsersInWorkspaceRequest {
  query: string;
}

export interface IWorkspaceMember {
  user: IUserDisplayData;
  role: WorkspaceRole;
}

export const WorkspaceRole = { ...Workspace_Role };

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type WorkspaceRole = Workspace_Role;

export interface IWorkspace {
  name: string;
  description?: string;
  avatarUrl?: string;
  usersCount: number;
}

export interface IPersonalizedWorkspace {
  workspace: IWorkspace;
  role: WorkspaceRole;
  workspaceSetting?: IWorkspaceSetting;
  region?: string;
}

export interface IWorkspaceSetting {
  allowUserProfileEdit: boolean;
  allowUserDisplayNameEdit: boolean;
  requireMiddleName: boolean;
}
